import { createContext } from "react";

import { DupContext } from "../providers/dupFlow/DupFlow.interfaces";

export const DupFlowContext = createContext<DupContext | undefined>(undefined);
